/**
 * @desc Wijmo 진행률 셀 템플릿 (cssClass: WijmoIconButton 와 함께 사용)
 * @author
 * -------------------------------------------------------------------------------------
 *  Date.       author         Description
 * -------------------------------------------------------------------------------------
 * 2025.11.13   jshwang12     신규 생성
 */

// 상태 (ing : 진행중 / delay : 진행중(지연) / done : 완료 / none : 시작전)
type State = 'ing' | 'delay' | 'done' | 'none';

/**
 * 진행률 셀 템플릿
 * @param state 상태 (ing : 진행중 / delay : 진행중(지연) / done : 완료 / none : 시작전)
 * @param progRt  진행률
 * @param delay 지연일수
 * @param tooltip 툴팁
 * @param issue 이슈여부 (true인 경우 버튼 노출됨)
 * @constructor
 */
export const GridProgressCellTemplate = (
  state: State,
  progRt = 0,
  delay = 0,
  tooltip = '',
  issue = false
) => {
  let title = `${Math.floor(Number(progRt) * 10) / 10}%`;
  if (delay > 0) {
    title = `${title} (D+${delay.toLocaleString()})`;
  }
  return `<div class="progressWrap" data-tooltip="${tooltip || title}">
            <div class="progress ${state}"> 
                <span style="width:${progRt}%">${title}</span> 
            </div>
            ${issue ? '<button class="issue"></button>' : ''}
          </div>`;
};
